(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('subModulo', {
            parent: 'entity',
            url: '/sub-modulo?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'chamadosApp.subModulo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/submodulo/submodulo.html',
                    controller: 'SubModuloController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('subModulo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('subModulo.new', {
            parent: 'subModulo',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/submodulo/submodulo-dialog.html',
                    controller: 'SubModuloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                descricao: null,
                                projetoRedMine: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('subModulo', null, { reload: 'subModulo' });
                }, function() {
                    $state.go('subModulo');
                });
            }]
        })
        .state('subModulo.edit', {
            parent: 'subModulo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/submodulo/submodulo-dialog.html',
                    controller: 'SubModuloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SubModulo', function(SubModulo) {
                            return SubModulo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('subModulo', null, { reload: 'subModulo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
